import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';
import '../../assets/styles/header.css';
import api from '../../config/axios';

const Header = ({ onLogout }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [holdingNome, setHoldingNome] = useState('');
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    useEffect(() => {
        if (!user.holding_id) {
            setHoldingNome('');
            return;
        }
        api.get(`/holdings/${user.holding_id}`)
            .then((res) => setHoldingNome(res.data?.nome || ''))
            .catch(() => setHoldingNome(''));
    }, [user.holding_id]);

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        }
        navigate('/login');
    };

    return (
        <header className="app-header">
            <div className="header-logo">
                <span className="header-logo-text">{holdingNome}</span>
            </div>
            
            <div className="header-user">
                <div 
                    className="user-info" 
                    onClick={() => setShowDropdown(!showDropdown)}
                >
                    {user.foto ? (
                    <img 
                        src={user.foto} 
                            alt="User" 
                            className="user-avatar"
                        />
                    ) : (
                        <></>   
                    )}
                    <span className="user-name">{user.nome}</span>
                    <FaChevronDown className="dropdown-icon" />
                    
                    {showDropdown && (
                        <div className="user-dropdown">
                            <button onClick={() => { navigate('/usuarios'); setShowDropdown(false); }}>
                                Editar
                            </button>
                            <button onClick={handleLogout}>
                                Sair
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header; 